/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_UndoInputs */

const en_us2_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const pt_br2_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer`)
};

const es_419_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

const pt_pt2_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anular`)
};

const fr_fr2_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_de2_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig`)
};

const it_it2_profile_undo = /** @type {(inputs: Profile_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Profile_UndoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_undo = /** @type {((inputs?: Profile_UndoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_UndoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_undo(inputs)
	if (locale === "es-419") return es_419_profile_undo(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_undo(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_undo(inputs)
	if (locale === "de-DE") return de_de2_profile_undo(inputs)
	if (locale === "it-IT") return it_it2_profile_undo(inputs)
	return en_us2_profile_undo(inputs)
});
export { profile_undo as "profile.undo" }